<div class="card-body p-b-0">
  <div class="row">
    <div class="col-md-12">
      <app-grid [autosize]="false" [rowData]="rowData" [columnDefs]="columnDefs" gridHeight="400px" [rowSelection]="'single'" #grid1>
      </app-grid>
    </div>
  </div>
</div>